define('rest/structuredGeocode',['http', './utils', "security"],
    function (http, utils, security) {
        "use strict";

        var queryParamNames = [
            'limit', 'ofs', 'streetNumber', 'streetName', 'crossStreet', 'municipality', 'municipalitySubdivision',
            'countryTertiarySubdivision', 'countrySecondarySubdivision', 'countrySubdivision', 'postalCode'
        ];

        return {
            structuredGeocode: function (options, callback) {
                var pathParams = {}, queryParams = {};

                // Required: "countryCode" param
                queryParams.countryCode = utils.required(options.countryCode, "\"countryCode\" parameter is required for structuredGeocode service.");

                // if an API key is specified, include it
                // an API key can be omitted if an API proxy is being used
                queryParams.key = utils.or(options.key, security.getKey("services/search"));

                utils.extractQueryParams(options, queryParams, queryParamNames);

                var baseUrl = utils.or(options.baseUrl, "{protocol}://api.tomtom.com/");
                var serviceUrl = utils.or(options.serviceUrl, "search/2/structuredGeocode.{contentType}");

                http.get({
                    url: baseUrl + serviceUrl,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    callbackParam: "callback",
                    fail: options.fail
                });
            }
        };
    }
);
